import React, { useEffect, useState } from "react";
import "./editmodal.css";
import { Modal } from "react-bootstrap";
import { message, Select } from "antd";
import Instance from "../../../AxiosConfig";
import { FaTrashAlt } from "react-icons/fa";

const EditAgentModal = ({ show, handleClose, agentData, fetchData }) => {
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [target, setTarget] = useState("");
  const [managerData, setManagerData] = useState([]);
  const [employmentHistory, setEmploymentHistory] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  /* =========================
     FETCH MANAGERS
  ========================== */
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await Instance.get("/agents/managers");
        console.log("Members fetch response:", res.data);
        if (res?.data?.managers) {
          setManagerData(res.data.managers);
        }
      } catch (err) {
        console.error("Members fetch error:", err);
        message.error("Failed to load members");
      }
    };

    fetchMembers();
  }, []);

  /* =========================
     PREFILL DATA ON EDIT
  ========================== */
  useEffect(() => {
    if (show && agentData) {
      setName(agentData.agentName || "");
      setEmail(agentData.email || "");
      setMobileNumber(agentData.number || "");
      setSelectedManager(agentData.managerId || undefined);

      setEmploymentHistory(
        (agentData.employmentHistory || []).map((item) => ({
          joiningDate: item.joiningDate
            ? item.joiningDate.slice(0, 10)
            : "",
          exitDate: item.exitDate
            ? item.exitDate.slice(0, 10)
            : "",
        }))
      );
    }

    if (!show) {
      setName("");
      setEmail("");
      setMobileNumber("");
      setTarget("");
      setSelectedManager(undefined);
      setEmploymentHistory([]);
    }
  }, [show, agentData]);

  const updateEmployment = (index, field, value) => {
    const updated = [...employmentHistory];
    updated[index][field] = value;
    setEmploymentHistory(updated);
  };

  const addEmployment = () => {
    setEmploymentHistory([
      ...employmentHistory,
      {
        joiningDate: "",
        exitDate: "",
      },
    ]);
  };

  const removeEmployment = (index) => {
    const updated = employmentHistory.filter((_, i) => i !== index);
    setEmploymentHistory(updated);
  };
  /* =========================
     MANAGER OPTIONS
  ========================== */
  const managerOptions = managerData.map((manager) => ({
    label: manager.agentName, // change if API uses fullName
    value: manager._id,
  }));

  /* =========================
     SAVE HANDLER
  ========================== */
  const handleSave = async () => {
    try {
      const putPayload = {
        agentName: name,
        agentEmail: email,
        agentNumber: mobileNumber,
        parentAgentId: selectedManager,
        role: "AGENT",
        employmentHistory: employmentHistory.map((item) => ({
          joiningDate: item.joiningDate,
          exitDate: item.exitDate || null,
        })),
      };


      for (const history of employmentHistory) {
        if (
          history.joiningDate &&
          history.exitDate &&
          new Date(history.exitDate) < new Date(history.joiningDate)
        ) {
          message.error(
            "Exit date cannot be before joining date."
          );
          return;
        }
      }

      const putResponse = await Instance.put(
        `/agents/${agentData._id}`,
        putPayload,
      );

      if (putResponse.status === 200 || putResponse.status === 201) {
        message.success("Agent details updated successfully!");
        handleClose();
        fetchData();
      } else {
        message.error("Failed to update agent details.");
      }
    } catch (error) {
      console.error("Update error:", error);

      // ✅ Log error response if available
      if (error.response) {
        console.error("Error Response Data:", error.response.data);
        console.error("Error Status:", error.response.status);
      }

      message.error("Failed to update agent details.");
    }
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Agent</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">
              {/* Agent Name */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Agent Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter agent name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              {/* Email */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Mobile */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Mobile Number</label>
                <input
                  className="form-control"
                  type="text"
                  value={mobileNumber}
                  onChange={(e) => {
                    // console.log(e.target.value);
                    setMobileNumber(e.target.value);
                  }}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Employment History</label>

                {employmentHistory.map((item, index) => (
                  <div
                    key={index}
                    className="border rounded p-3 mb-3"
                  >
                    <div className="row">
                      <div className="col-md-5">
                        <label>Joining Date</label>

                        <input
                          type="date"
                          className="form-control"
                          value={item.joiningDate}
                          onChange={(e) =>
                            updateEmployment(
                              index,
                              "joiningDate",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div className="col-md-5">
                        <label>Exit Date</label>

                        <input
                          type="date"
                          className="form-control"
                          value={item.exitDate}
                          min={item.joiningDate}
                          onChange={(e) =>
                            updateEmployment(
                              index,
                              "exitDate",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div className="col-md-2 d-flex align-items-end">
                        <button
                          type="button"
                          className="btn btn-danger w-100"
                          onClick={() => removeEmployment(index)}
                        >
                           <FaTrashAlt />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={addEmployment}
                >
                  + Add Employment
                </button>
              </div>

              {/* Assign Manager */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Assign Manager</label>
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Select manager"
                  value={selectedManager}
                  options={managerOptions}
                  onChange={(value) => setSelectedManager(value)}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-2">
              <button
                type="button"
                className="agents-discard-button"
                onClick={handleClose}
              >
                Discard Changes
              </button>

              <button
                type="button"
                className="agents-save-button"
                onClick={handleSave}
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditAgentModal;
